import axios from './axios'
import config from '../config'

export default {
    listReportCategories() {
        return axios({
            url: config.backendUrl + '/project/reports/categories',
            method: 'GET',
        })
    },
    listReports(params) {
        return axios({
            url: config.backendUrl + '/project/reports',
            method: 'GET',
            params
        })
    },
    addReport(data) {
        return axios({
            url: config.backendUrl + '/project/reports',
            method: 'POST',
            data
        })
    },
    updateReport(data) {
        return axios({
            url: config.backendUrl + '/project/reports',
            method: 'PUT',
            data
        })
    },
    getReport(id) {
        return axios({
            url: config.backendUrl + '/project/reports/' + id,
            method: 'GET'
        })
    },
    deleteReport(id) {
        return axios({
            url: config.backendUrl + '/project/reports/' + id,
            method: 'DELETE'
        })
    }
}
